<template>
  <div class="personal">
    <div class="grzx-con">
      <div>
        <div class="title grzx"></div>
        <div>
          <div :class="['personal-info',{'lessitem':!showitems},{'moreitem':showitems}]">
            <div class="leftnav">

              <div class="myaccount">我的账户</div>
              <ul class="items">
                <li :class="[{'active':activeTab=='jbxx'}]" @click="activeTab='jbxx'">
                  <img v-if="activeTab=='jbxx'" src="../assets/jbxx-b.png"/>
                  <img v-else src="../assets/jbxx-w.png"/>
                  基本信息
                </li>
                <!-- 2023-3-2不展示净值填报&我要报名按钮 -->
                <!-- <li v-if="showitems" :class="[{'active':activeTab=='jztb'}]" @click="addJz">
                  <img v-if="activeTab=='jztb'" src="../assets/jztb-b.png"/>
                  <img v-else src="../assets/jztb-w.png"/>
                  净值填报
                </li> -->
                <li v-if="showitems" :class="[{'active':activeTab=='jzck'}]" @click="seeJz('jzck')">

                  <img v-if="activeTab=='jzck'" src="../assets/jzck-b.png"/>
                  <img v-else src="../assets/jzck-w.png"/>
                  净值查看
                </li>
<!--                <li v-if="showitems" :class="[{'active':activeTab=='fsxg'}]" @click="changeType">-->
<!--                  <img v-if="activeTab=='fsxg'" src="../assets/jzxg-b.png"/>-->
<!--                  <img v-else src="../assets/jzxg-w.png"/>-->
<!--                  净值填报方式修改-->
<!--                </li>-->
                <li :class="[{'active':activeTab=='mmxg'}]" @click="activeTab='mmxg'">
                  <img v-if="activeTab=='mmxg'" src="../assets/xgmm-b.png"/>
                  <img v-else src="../assets/xgmm-w.png"/>
                  修改账户密码
                </li>
                <li :class="[{'active':activeTab=='ggsj'}]" @click="activeTab='ggsj'">
                  <img v-if="activeTab=='ggsj'" src="../assets/ggsj-b.png"/>
                  <img v-else src="../assets/ggsj-w.png"/>
                  更改绑定手机号
                </li>
              </ul>
              <div class="aboutbutton">
                <div class="itembutton" @click="logout">退出登录</div>
                <div class="itembutton" @click="goQh">切换至期货大赛个人中心</div>
              </div>
            </div>
            <div class="itemcontent">
              <div class="basic-info" v-if="activeTab=='jbxx'&&basicInfo&&!basicInfo.institut&&basicInfo.investor">
                <div class="tel">账号/绑定手机号：{{basicInfo.investor.mobile}}</div>
                <!-- <div class="gosign" @click="gosignup">我要报名</div> -->
              </div>
              <div class="basic-info" v-if="activeTab=='jbxx'&&basicInfo&&basicInfo.institut">
                <div v-if="infoType =='basic'">
                <ul class="my-info">
                  <table border="1" cellspacing="0">
                    <tr>
                      <td><span class="name">公司全称：</span></td>
                      <td><span class="con">{{basicInfo.institut.institutName}}</span></td>
                    </tr>
                    <tr>
                      <td><span class="name">中基协登记编号：</span></td>
                      <td><span class="con">{{basicInfo.institut.institutRecordNum}}</span></td>
                    </tr>
                    <tr>
                      <td><span class="name">管理规模：</span></td>
                      <td><span class="con">{{basicInfo.institut.assetSize}} 元</span></td>
                    </tr>
                    <tr>
                      <td><span class="name">联系人信息：</span><br><el-button type="warning" size="mini" @click="contactinfo('contactInfo')">修改</el-button></td>
                      <td><span class="name">联系人：</span><span class="con">{{basicInfo.institut.linkman}}</span><br>
                        <span class="name">联系人手机：</span><span class="con">{{basicInfo.institut.linkmanMobile}}</span><br>
                        <span class="name">联系人邮箱：</span><span class="con">{{basicInfo.institut.linkmanEmail}}</span>
                      </td>
                    </tr>
                    <tr>
                      <td><span class="name">参赛产品：</span><br><el-button v-if="basicInfo.institut.productList&&competNum>0" type="warning" size="mini" @click="contactinfo('productWithdrawal')">产品退赛</el-button></td>
                      <td><li v-for="(item,index) in basicInfo.institut.productList" :key="index"><span class="name">参赛产品{{index+1}}：</span><span
                        class="con">{{item.productShortName}}</span></li></td>
                    </tr>
                    <tr>
                      <td><span class="name">退赛产品：</span></td>
                      <td><li v-for="(item,index) in basicInfo.institut.productTsList" :key="index"><span class="name">参赛产品{{index+1}}：</span><span
                        class="con">{{item.productShortName}}</span></li></td>
                    </tr>
                  </table>
                </ul>
                <!-- <div class="gosign" v-if="basicInfo.institut.productList&&competNum<8" @click="gosignup">我要报名</div>
                <div class="gosign" v-if="!basicInfo.institut.productList" @click="gosignup">我要报名</div> -->
              </div>
              <div v-if="infoType == 'contactInfo'">
                <h3>联系人信息修改</h3>
                <el-form  class="formcenter" label-position="left" label-width="100px" :model="formLabelAlign">
                  <el-form-item label="联系人：">
                    <el-input v-model="formLabelAlign.institut.linkman"></el-input>
                  </el-form-item>
                  <el-form-item label="联系人手机：">
                    <el-input onkeyup="value=value.replace(/[^\d]/g,'')" v-model="formLabelAlign.institut.linkmanMobile"></el-input>
                  </el-form-item>
                  <el-form-item label="联系人邮箱：">
                    <el-input v-model="formLabelAlign.institut.linkmanEmail"></el-input>
                  </el-form-item>
                  <el-form-item label="验证码：">
                    <el-input v-model="formLabelAlign.verifyCode" @input="isVerifyCode" placeholder="发送至账户绑定手机号">
                      <el-button @click="sendCode" :disabled="isDisabled" slot="append" style="color: #E6A23C;background-color: #fff;"><span>{{ buttonName }}</span></el-button>
                    </el-input>
                  </el-form-item>
                  <div class="remindText">信息变更一天一次，请谨慎变更！</div>
                  <el-form-item>
                    <el-button style="width: 100px;" :disabled="btntype == 'info'" :type="btntype" @click="changeLinkmanInfo">确认更改</el-button>
                    <el-button style="width: 100px;margin-left: 80px;" type="warning" @click="infoType = 'basic'">返回</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div v-if="infoType == 'productWithdrawal'">
                <h3>产品退赛</h3>
                <div class="formcenter">
                <el-checkbox-group size="medium" v-model="checkList" @change="isSignOut">
                  <el-checkbox size="medium" class="test" :label="item.id" v-if="item.competingStatus == 1" v-for="(item,index) in basicInfo.institut.productList" :key="index">{{'参赛产品'+ (index+1) +'：' + item.productShortName}}</el-checkbox><br>
                </el-checkbox-group>
                  <el-button :disabled="signOutBtn == 'info'" :class="signOutBtn == 'info'?'notSingOut':'isSignOut'" :type="signOutBtn" style="width: 100px;margin-top: 20px;" @click="sureOut">确认退赛</el-button>
                  <el-button style="width: 100px;margin-left: 80px;" type="warning" @click="infoType = 'basic'">返回</el-button>
                </div>
              </div>
             </div>

              <div class="basic-info" v-if="activeTab=='jztb'">
                <div v-if="tbproductList.length!=0">
                  <ul class="cards">
                    <li :class="{'activecards':cards==index}" @click="getCards(index,item.lhmjPofProduct.productName)"
                        v-for="(item,index) in tbproductList" :key="index">{{item.lhmjPofProduct.productShortName}}
                    </li>
                  </ul>
                  <product-info :class="['hidetable',{'showtable':cards==index}]" v-for="(item,index) in tbproductList"
                                :key="index" :productInfo="item" @refreshList="refreshList"></product-info>
                </div>
                <div v-if="tbproductList.length==0">暂无需要填报的产品</div>
              </div>
              <div class="basic-info" v-if="activeTab=='jzck'">
                <div v-if="ckproductList.length!=0">
                  <ul class="cards">
                    <li :class="{'activecards':ckcards==index}"
                        @click="getckCards(index,item.lhmjPofProduct.productName)" v-for="(item,index) in ckproductList"
                        :key="index">{{item.lhmjPofProduct.productShortName}}
                    </li>
                  </ul>

                  <ckproduct-info :class="['hidetable',{'showtable':ckcards==index}]"
                                  v-for="(item,index) in ckproductList" :key="index"
                                  :productInfo="item"></ckproduct-info>
                </div>
                <div v-if="ckproductList.length==0">暂无可查看的产品</div>
              </div>
              <div class="basic-info" v-if="activeTab=='fsxg'">
                <div v-if="productsList.length!=0" class="tbtypes">
                  <div class="checkitem" v-for="(item,index) in productsList" :key="index">
                    <div>{{item.productName}}</div>
                    <div>
                      <div class="radio-box"><input :name="index" :id="'tbtype0'+index" type="radio" v-model="item.valuationSubmittype"
                                                    value="1"/><label :for="'tbtype0'+index">自行页面填报<span>（登录后，进入个人中心填报）</span></label>
                      </div>
                      <div class="radio-box"><input :name="index" :id="'tbtype1'+index" type="radio" v-model="item.valuationSubmittype"
                                                    value="2"/><label :for="'tbtype1'+index">托管邮箱发送</label><input
                        v-model="item.submitEmail" placeholder="请填写邮箱" @focus="activeinput(index)"
                        :class="['input',{'activeinput':active==index}]"/>
                      </div>
                      <div class="radio-box"><input :name="index" :id="'tbtype2'+index" type="radio" v-model="item.valuationSubmittype"
                                                    value="3"/><label :for="'tbtype2'+index">其他<span>（见确认邮件）</span></label>
                      </div>
                    </div>
                  </div>
                  <div class="surechange" @click="surechangefsType">确认修改</div>
                </div>
                <div v-if="productsList.length==0">暂无可修改的净值填报方式</div>
              </div>
              <div class="basic-info mmxg" v-if="activeTab=='mmxg'">
                <div class="inputdiv"><label>旧密码：</label><input type="password" v-model="pwd"/></div>
                <div class="inputdiv"><label>新密码：</label><input type="password" v-model="newpwd"/></div>
                <div class="inputdiv"><label>请确认密码：</label><input type="password" v-model="surepwd"/></div>
                <div class="surechange" @click="surechangepwd">确认更改</div>
              </div>
              <div class="basic-info ggsj" v-if="activeTab=='ggsj'">
                <div class="inputdiv"><label>已绑定手机号：</label><span style="display: inline-block;width: 280px;text-align: left;">{{bindMobile}}</span>
                  <el-button type="warning" v-if="!isCancel" @click="cancelAccount">注销</el-button>
                </div>
                <div class="inputdiv"><label>手机号：</label><input v-model="mobile"/></div>
                <div class="inputdiv"><label>验证码：</label><input v-model="verifyCode"/>
                  <div v-if="getverification" class="vercode" @click="getvercode">获取验证码</div>
                  <div v-if="!getverification" class="vercode">重新发送({{count}})S</div>
                </div>
                <div class="surechange" @click="surechangeMobile">确认更改</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    <risknotice v-if="showrisknotice" @closerisknotice="closerisknotice"></risknotice>-->
  </div>
</template>
<script>
  import {http} from '../fetch/api'
  import format from '../fetch/format'
  import productInfo from './productInfo'
  import ckproductInfo from './ckproductInfo'
  // import risknotice from './risknotice'
  import Utils from '@/fetch/utils'
  import qs from 'qs';
  export default {
    components: {
      productInfo,
      ckproductInfo
      // risknotice
    },
    data() {
      return {
        activeTab: 'jbxx',
        pwd: "",
        newpwd: "",
        surepwd: "",
        mobile: "",
        verifyCode: "",
        basicInfo: {},
        cards: 0,
        ckcards: 0,
        tbproductList: [],
        ckproductList: [],
        productList: [],
        productTsList: [],
        productsList: [],
        productName: "",
        valuationSubmittype: "1",
        submitEmail: "",
        // showrisknotice: false
        showitems: false,
        getverification: true,
        count: 30,
        timer: null,
        active: false,
        competNum:0,
        infoType:"basic",
        CountDown: 30,
        buttonName: "获取验证码",
        isDisabled: false,
        formLabelAlign: {},
        checkList: [],
        btntype:'info',
        signOutBtn:'info',
        bindMobile:"",
        isCancel:true
      }
    },
    mounted() {
      if(this.$store.state.loginState) {
        if (window.localStorage.institutId != 'null') {//有私募管理人信息显示5项，没有显示3项
          this.showitems = true
        } else {
          this.showitems = false
        }
        this.getbasicInfo()
      }else {
        var temp=format.formatKeys(this.$route.query)
        var params=temp.substring(0,temp.length-1)
        this.$router.push("/?"+params)
      }
      this.bindMobile = window.localStorage.mobile
      this.judgeProBaoming()
    },
    methods: {
      async cancelAccount(){
        let data = await http.cancelAccount()
        if(data.code == "0"){
          this.$router.push("/")
          this.$bus.$emit('brotherEvent')
        }
      },
      async judgeProBaoming(){
        let data = await http.judgeProBaoming(this.bindMobile)
        this.isCancel = data.data
      },
      contactinfo(changename){
        this.infoType = changename
      },
      async sendCode(){
        if (!this.formLabelAlign.institut.linkmanMobile) {
          this.$store.state.noticeMessage="请输入手机号"
          return
        }
        if(!(/^1[3456789]\d{9}$/.test(this.formLabelAlign.institut.linkmanMobile))) {
          this.$store.state.noticeMessage="请输入合法的手机号"
          return
        }
        var type = '6'
        var data = await http.verifyCode(this.bindMobile, type)
        if(data.code == "0"){
          this.$store.state.noticeMessage="验证码已发送"
        }
        this.isDisabled = true;
        let timerId = setInterval(() => {
          this.CountDown--;
          this.buttonName ="重新发送（"+ this.CountDown + "）S";
          if (this.CountDown <= 0) {
            clearInterval(timerId);
            this.buttonName = "重新发送";
            this.CountDown = 30;
            this.isDisabled = false;
          }
        }, 1000);
      },
      async changeLinkmanInfo(){
      if (!(/^[\u4e00-\u9fa5]{2,10}$/.test(this.formLabelAlign.institut.linkman))) {
        this.$store.state.noticeMessage="请输入2-10个汉字的联系人姓名"
        return
      }
      if(!(this.formLabelAlign.institut.linkmanMobile)) {
        this.$store.state.noticeMessage="请输入手机号"
        return
      }
      if(!(/^1[3456789]\d{9}$/.test(this.formLabelAlign.institut.linkmanMobile))) {
        this.$store.state.noticeMessage="请输入合法的手机号"
        return
      }
      if (!(/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(this.formLabelAlign.institut.linkmanEmail))) {
        this.$store.state.noticeMessage="请输入合法的邮箱"
        return
      }
        if (!this.formLabelAlign.verifyCode) {
          this.$store.state.noticeMessage="请输入验证码"
          return
        }
        let linkVo = {
          linkman:this.formLabelAlign.institut.linkman,
          linkmanEmail:this.formLabelAlign.institut.linkmanEmail,
          linkmanMobile:this.formLabelAlign.institut.linkmanMobile,
          verifyCode:this.formLabelAlign.verifyCode,
        }
        var data = await http.changeLinkmanInfo(linkVo)
        if(data.code == "0"){
          this.$store.state.noticeMessage="联系人信息修改成功"
          this.getbasicInfo()
          this.infoType = "basic"
        }
      },
      isVerifyCode(){
        if(this.formLabelAlign.verifyCode){
          this.btntype = "primary"
        }else {
          this.btntype = "info"
        }
      },
      isSignOut(){
        if(this.checkList.length>0){
          this.signOutBtn = "primary"
        }else {
          this.signOutBtn = "info"
        }
      },
      async sureOut(){
        let data = await http.signOutProducts({productIds:this.checkList.toString()})
        if(data.code == "0"){
          this.$store.state.noticeMessage="产品退赛成功"
          this.getbasicInfo()
          this.infoType = "basic"
        }
      },
      refreshList() {
        this.addJz()
      },
      async goQh() {
        var data = await http.changeToLhmj()
        if(data.code=='0') {
          window.location.href=window.location.origin+"/#/my"
        }
      },
      activeinput(index) {
        this.active=index
      },
      // closerisknotice() {
      // this.showrisknotice = false
      // },
      gosignup() {
        // this.showrisknotice = true
        var temp=format.formatKeys(this.$route.query)
        var params=temp.substring(0,temp.length-1)
        if (window.localStorage.institutId != 'null') {

          if (this.basicInfo && this.basicInfo.institut && ((this.basicInfo.institut.productList&& this.competNum < 8)||(!this.basicInfo.institut.productList))) {
            if(this.basicInfo.institut.productList) {
              window.localStorage.productList = this.basicInfo.institut.productList.length
            } else {
              window.localStorage.productList = 0
            }
            this.$router.push("/signup?"+params)
          } else {
            window.localStorage.productList = 8
            this.$store.state.noticeMessage = "您已有8个产品参赛，暂不能报名"
            return
          }
        } else {
          this.$router.push("/manager?"+params)
        }
      },
      async logout() {
        var data = await http.logout()
        if (data.code == '0') {
          this.$store.state.loginState = false
          var temp=format.formatKeys(this.$route.query)
          var params=temp.substring(0,temp.length-1)
          this.$router.push("/?"+params)
        }
      },
      async surechangefsType() {
        var data = await http.subTypeSubmit(this.productsList)
        if (data.code == "0") {
          // format.message('修改成功')
          this.$store.state.noticeMessage="修改成功"
        }
      },
      getCards(index, productName) {
        this.cards = index
        this.productName = productName

      },
      getckCards(index, productName) {
        this.ckcards = index
        this.productName = productName

      },
      async addJz() {
        var data = await http.jzBeforeSub()
        if (data.code == '0') {
          this.tbproductList = data.data
          this.activeTab = 'jztb'
        }
      },
      async seeJz(type) {
        var data = await http.queryJz()
        if (data.code == '0') {
          this.ckproductList = data.data
          this.activeTab = type
        }
      },
      async changeType() {
        // this.seeJz('fsxg')

        var data = await http.submitList()
        if (data.code == '0') {
          if (data.data && data.data.list) {
            this.productsList = data.data.list
          }
          this.activeTab = 'fsxg'
        }
      },
      async getbasicInfo() {
        var data = await http.basicInfo()
        this.basicInfo = data.data
        this.formLabelAlign = JSON.parse(JSON.stringify(data.data))
        for (let i = 0; i < this.basicInfo.institut.productList.length; i++) {
          if(this.basicInfo.institut.productList[i].competingStatus == "1"){
            this.competNum++
          }
        }
      },
      async surechangeMobile() {
        if (!this.mobile) {
        // format.message("请输入手机号", "error")
        this.$store.state.noticeMessage="请输入手机号"
        return
      }
        if(!(/^1[3456789]\d{9}$/.test(this.mobile))) {
          this.$store.state.noticeMessage="请输入合法的手机号"
          return
        }
        if (!this.verifyCode) {
          // format.message("请输入手机号", "error")
          this.$store.state.noticeMessage="请输入验证码"
          return
        }
        var data = await http.changeMobile(this.mobile, this.verifyCode)
        if (data.code == '0') {
          this.$store.state.noticeMessage="绑定手机号码已修改"
          this.bindMobile = data.data
          this.bindMobile = data.data
          this.getbasicInfo()//修改手机号后重新获取基本信息
        }
      },
      async getvercode() {
        if (!this.mobile) {
          // format.message("请输入手机号", "error")
          this.$store.state.noticeMessage="请输入手机号"
          return
        }
        if(!(/^1[3456789]\d{9}$/.test(this.mobile))) {
          this.$store.state.noticeMessage="请输入合法的手机号"
          return
        }
        var type = '4'
        var data = await http.verifyCode(this.mobile, type)
        if (data.code == '0') {
          // format.message("验证码已发送")
          this.$store.state.noticeMessage="验证码已发送"
        }

        const TIME_COUNT = 30;
        if (!this.timer) {
          // this.count = TIME_COUNT;
          var dhTime = window.localStorage.setdhTime = new Date().getTime()
          this.getverification = false;
          this.count = 30
          this.timer = setInterval(() => {
            // var setdhTime =
            this.count = TIME_COUNT - Math.round((new Date().getTime() - dhTime) / 1000)
            if (this.count > 0 && this.count <= TIME_COUNT) {
              // this.count--;
            } else {
              this.getverification = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000)
        }
      },
      async surechangepwd() {
        if(!this.newpwd) {
          this.$store.state.noticeMessage="请输入新密码"
          return
        }
        if (this.newpwd != this.surepwd) {
          // format.message("请确认密码是否一致", "error")
          this.$store.state.noticeMessage="请确认密码是否一致"
          return
        }

        var pwd=Utils.encrypt(this.pwd)
        var newpwd=Utils.encrypt(this.newpwd)
        var data = await http.changePassword(pwd, newpwd)
        if (data.code == '0') {
          // format.message("密码修改成功")
          this.$store.state.noticeMessage="密码修改成功"
          this.pwd=""
          this.newpwd=""
          this.surepwd=""
        }
      }
    }
  }
</script>
<style scoped>
  .formcenter {
    width: 500px;
    padding-left: 170px;
    padding-top: 40px;
  }
  .formcenter .el-checkbox {
    color: #000;
    padding: 10px 0;
  }
  .remindText {
    color: red;
    padding: 20px;
    text-align: center;
  }
  .notSignOut {
    background: #ccc;
    border: #ccc;
  }
  .isSignOut{
    background: #0d225c;
    border: #0d225c;
  }




  
  .grzxtext {
    height: 60px;
    line-height: 60px;
    background: #f4f7f9;
  }

  .grzxtext div {
    width: 1200px;
    margin: 0 auto;
    font-size: 16px;
  }

  .title span {
    padding-left: 50px;
    display: inline-block;
    background-image: -webkit-linear-gradient(73deg, #0c3b95, #cf5860);
    background-image: -o-linear-gradient(73deg, #0c3b95, #cf5860);
    background-image: -moz-linear-gradient(73deg, #0c3b95, #cf5860);
    background-image: linear-gradient(73deg, #0c3b95, #cf5860);
    -webkit-background-clip: text;
    -ms-background-clip: text;
    -o-background-clip: text;
    -moz-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    -o-text-fill-color: transparent;
    -moz-text-fill-color: transparent;
    text-fill-color: transparent;
    font-weight: bold;

  }

  .title {
    height: 67px;
    line-height: 67px;
    text-align: center;
    font-size: 30px;
    letter-spacing: 5px;
    margin: 0 auto 35px auto;
    background-repeat: no-repeat;
    background-size: 750px;
    background-position: center;
  }

  .grzx-con > div {
    padding: 50px 0;
    width: 1200px;
    margin: 0 auto;
  }

  .grzx {
    background-image: url("../assets/grzx.png");
  }

  .personal-info {
    width: 1200px;
    background-repeat: no-repeat;
    background-size: contain;
  }

  .lessitem {
    height: 682px;
    background-image: url("../assets/lessitem.png");
  }

  .moreitem {
    height: 876px;
    background-image: url("../assets/moreitem.png");
  }

  .myaccount {
    height: 100px;
    line-height: 100px;
    text-align: center;
    font-family: MicrosoftYaHei-Bold;
    font-size: 26px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 1px;
    color: #0d225c;
  }

  .items li {
    list-style: none;
    height: 97px;
    line-height: 97px;
    padding-left: 50px;
    font-family: MicrosoftYaHei-Bold;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 1px;
    color: #7ec4f7;
  }

  .items img {
    width: 30px;
    vertical-align: middle;
    margin-right: 10px;
  }

  li.active {

    background: -webkit-linear-gradient(left, rgba(216, 243, 255, 0), rgba(160, 221, 250, 1)); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(right, rgba(216, 243, 255, 0), rgba(160, 221, 250, 1)); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(right, rgba(216, 243, 255, 0), rgba(160, 221, 250, 1)); /* Firefox 3.6 - 15 */
    background: linear-gradient(to right, rgba(216, 243, 255, 0), rgba(160, 221, 250, 1)); /* 标准的语法 */

    font-family: MicrosoftYaHei-Bold;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 1px;
    color: #0d225c;
  }

  .leftnav {
    display: inline-block;
    width: 285px;
  }

  .itemcontent {
    display: inline-block;
    width: 900px;
    vertical-align: top;
    padding: 60px 30px;
    box-sizing: border-box;
  }

  .basic-info {
  }

  .basic-info .tel {
    height: 40px;
    line-height: 40px;

    font-family: MicrosoftYaHei-Bold;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 32px;
    letter-spacing: 1px;
    color: #303030;
  }

  .gosign {
    width: 210px;
    height: 50px;
    line-height: 50px;
    background-image: url("../assets/gosign.png");
    background-repeat: no-repeat;
    background-size: contain;
    color: #fff;

    font-family: MicrosoftYaHei-Bold;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 1px;
    text-align: center;
    margin-top: 20px;
    text-shadow: 2px 2px 20px #0ff;
  }

  .aboutbutton {
    margin-top: 30px;
    text-align: center;
  }

  .itembutton {
    width: 220px;
    height: 40px;
    line-height: 40px;
    background: #0d225c;
    border-radius: 6px;
    text-align: center;
    color: #fff;
    margin: 15px auto;
    display: inline-block;
    text-decoration: none;
  }

  .ggsj, .mmxg {
    text-align: center;
  }

  .ggsj .inputdiv, .mmxg .inputdiv {
    position: relative;
    display: inline-block;
    padding: 10px;
  }

  .inputdiv label {
    display: inline-block;
    width: 120px;
    font-size: 16px;
    text-align: right;
  }

  .ggsj input, .mmxg input {
    border-radius: 6px;
    height: 40px;
    line-height: 40px;
    outline: none;
    padding: 0 10px;
    width: 350px;
    box-sizing: border-box;
    border: solid 1px #aaa;
  }

  .surechange {
    width: 220px;
    height: 40px;
    line-height: 40px;
    background: #0d225c;
    margin: 0 auto;
    border-radius: 6px;
    color: #fff;
    margin-top: 30px;
    text-align: center;
  }

  .my-info {
    list-style: none;
  }

  .my-info li {
    height: 32px;
    line-height: 32px;
  }

  .my-info .name {
    display: inline-block;
    text-align: right;
    font-size: 16px;
    letter-spacing: 1px;
    /* width: 140px; */
    font-family: MicrosoftYaHei-Bold;
  }

  .cards {
    padding: 20px 0;
  }

  .cards li {
    list-style: none;
    display: inline-block;
    height: 34px;
    line-height: 20px;
    margin: 0 10px;
    padding: 0 10px;
    box-sizing: border-box;
  }

  .cards li.activecards {
    border: 7px solid;
    border-image: url("../assets/bgcards.png") 20 stretch;
    background-repeat: no-repeat;

  }


  .radio-box {
    display: inline-block;
  }

  .radio-box .input {
    width: 250px;
    height: 40px;
    border-radius: 6px;
    margin-left: 5px;
    padding: 0 10px;
    box-sizing: border-box;
    border: solid 1px #cacaca;
    outline: none;
  }
  .radio-box .activeinput {
    border-color: #27a7ea;
  }
.radio-box label span {
  color: #cacaca;
}
  .checkall {
    margin: 20px 0;
  }

  .checkitem {
    margin: 20px 0;
  }

  .vercode {
    text-align: center;
    display: inline-block;
    width: 120px;
    border-left: solid 1px #5f9be7;
    position: absolute;
    top: 15px;
    right: 10px;
    height: 30px;
    line-height: 30px;
    color: #5f9be7;
  }

  .hidetable {
    display: none;
  }

  .showtable {
    display: block;
  }

  .tbtypes {
    height: 760px;
    overflow: auto;
  }
    /*滚动条整体样式*/
  .tbtypes::-webkit-scrollbar {
    width: 8px;
    height: 1px;
  }

  /*滚动条滑块*/
  .tbtypes::-webkit-scrollbar-thumb {
    border-radius: 0px;
    -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.1);
    background: #a4f1fc;
  }

  /*滚动条轨道*/
  .tbtypes::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0);
    border-radius: 10px;
    background: none;
  }

  table{
    border-top: 1px solid #ccc;
    border-left: 1px solid #ccc;
    border-collapse: collapse; 
}
td{
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
}


  table tr td:nth-child(1){
    width: 200px;
    text-align: center;
  }
  table tr td:nth-child(2){
    width: 600px;
    padding: 10px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/personal.vue